// resources/js/stripe-payment-method.js
export function initStripePayment({
    stripeKey,
    setupIntent,      // the full SetupIntent object or at least client_secret
    selectors: {
        sepaForm,
        cardForm,
        sepaRadio,
        cardRadio,
        ibanMount,
        cardMount,
        sepaErrors,
        cardErrors,
        bankName,
        form,
        submitBtn,
        givenName,
        familyName,
        email,
    },
    cardStyleOptions,
    sepaStyleOptions
}) {
    // payment method toggle
    document.querySelector(cardForm).style.display = 'none';
    document.querySelector(sepaRadio).addEventListener('click', () => {
        document.querySelector(ibanMount).closest(sepaForm).style.display = '';
        document.querySelector(cardMount).closest(cardForm).style.display = 'none';
    });
    document.querySelector(cardRadio).addEventListener('click', () => {
        document.querySelector(ibanMount).closest(sepaForm).style.display = 'none';
        document.querySelector(cardMount).closest(cardForm).style.display = '';
    });

    const stripe = Stripe(stripeKey);
    const elements = stripe.elements();

    // IBAN
    const iban = elements.create('iban', {
        supportedCountries: ['SEPA'],
        style: {
            base: sepaStyleOptions,
        }
    });
    iban.mount(ibanMount);

    // Card
    const card = elements.create('card', {
        style: {
            base: cardStyleOptions
        }
    });
    card.mount(cardMount);

    // Error containers
    const sepaErrEl = document.querySelector(sepaErrors);
    const cardErrEl = document.querySelector(cardErrors);
    const bankNameEl = document.querySelector(bankName);

    iban.on('change', evt => {
        sepaErrEl.textContent = evt.error?.message || '';
        if (evt.bankName) {
            bankNameEl.textContent = evt.bankName;
            bankNameEl.classList.add('visible');
        } else {
            bankNameEl.classList.remove('visible');
        }
    });

    card.on('change', evt => {
        cardErrEl.textContent = evt.error?.message || '';
    });
    // form submission
    const paymentForm = document.querySelector(form);
    paymentForm.addEventListener('submit', e => {
        e.preventDefault();
        lock();
        const choice = document.querySelector('[name="payment-method"]:checked').id;
        const name = document.querySelector(givenName).value + ' ' + document.querySelector(familyName).value;
        const mail = document.querySelector(email).value;

        const opts = {
            payment_method: {
                billing_details: { name, email: mail }
            }
        };
        if (choice === 'sepa') {
            opts.payment_method.sepa_debit = iban;
            stripe.confirmSepaDebitSetup(setupIntent.client_secret, opts).then(handleResult('sepa'));
        } else {
            opts.payment_method.card = card;
            stripe.confirmCardSetup(setupIntent.client_secret, opts).then(handleResult('card'));
        }
    });

    function lock() {
        document.querySelector(submitBtn).disabled = true;
        document.querySelector(submitBtn).innerHTML = `<span class="spinner-border spinner-border-sm"></span> Loading…`;
        card.update({ disabled: true });
        iban.update({ disabled: true });
    }

    function unlock() {
        document.querySelector(submitBtn).disabled = false;
        document.querySelector(submitBtn).textContent = 'kostenpflichtig Registrieren';
        card.update({ disabled: false });
        iban.update({ disabled: false });
    }

    function handleResult(type) {
        return result => {
            if (result.error) {
                const msg = result.error.code === 'parameter_invalid_empty'
                    ? 'Name wurde nicht ausgefüllt'
                    : result.error.message;
                if (type === 'card') cardErrEl.textContent = msg;
                else sepaErrEl.textContent = msg;
                unlock();
            } else {
                sepaErrEl.classList.remove('visible');
                cardErrEl.classList.remove('visible');
                // inject paymentMethod into form and submit
                const hidden = document.createElement('input');
                hidden.type = 'hidden';
                hidden.name = 'paymentMethod';
                hidden.value = result.setupIntent.payment_method;
                paymentForm.appendChild(hidden);
                paymentForm.submit();
            }
        };
    }
}

if (typeof window !== 'undefined') {
    window.initStripePayment = initStripePayment;
  }